import { RefBool, Ref, RefString } from '@tblabs/truffle';
import { v4 as uuidv4 } from 'uuid';
import { BlobPicture } from './BlobPicture';
import { OcrState, UploadState } from './UploadState';


export class Snap
{
    public Id: string;
    public Picture: BlobPicture;
    public IsSelectedByUser = new RefBool(false);
    public UploadState = new Ref<UploadState>(UploadState.NotUploaded);
    public OcrState = new Ref<OcrState>(OcrState.NoOcr);
    public OcrText: string | null = null;

    constructor(picture: BlobPicture)
    {
        this.Id = uuidv4();
        this.Picture = picture;
    }

    public Upload(): void
    {
        this.UploadState.value = UploadState.StartUploading;
    }

    private StartOcr(): void
    {
        this.OcrState.value = OcrState.Started;
    }

    private get WasOcred(): boolean
    {
        return this.OcrText !== null;
    }

    public ObtainOcrText(): void
    {
        if (this.WasOcred) 
        {
            this.OcrState.ForceOnChange();
        }
        else
        {
            this.StartOcr();
        }
    }
}
